module.exports = __webpack_public_path__ + "img/share.c00cbfb4.png";